import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Signup from '../views/Signup.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Layout from '../Layout/index.vue'
//import FullLayout from '../Layout/FullLayout.vue'
import Admin from '../views/Admin/index.vue'
import AdminLayout from '../Layout/AdminLayout.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'NoLogin',
    redirect: '/Login',
    meta: {
      title: "Login"
    }
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: {
      title: "Login"
    }
  },
  {
    path: '/Signup',
    name: 'Signup',
    component: Signup,
    meta: {
      title: "Signup"
    }
  },
  {
    path: '/ForgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: {
      title: "Forget Password"
    }
  },
  {
    path: '/ResetPassword',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      title: "Reset Password"
    }
  },
  {
    path: '/Home',
    component: Layout,
    children: [{
      path: '/',
      name: 'Home',
      meta: { 
        title: 'Welcome'
      },
      component: () => import('@/views/Home'),
    }]
  },
  {
    path: '/CodeList',
    component: Layout,
    children: [{
      path: '/',
      name: 'CodeList',
      meta: { 
        title: 'Code List'
      },
      component: () => import('@/views/CodeList'),
    }]
  },
  {
    path: '/SubscribedCodes',
    component: Layout,
    children: [{
      path: '/',
      name: 'SubscribedCodes',
      meta: { 
        title: 'Subscribed Codes'
      },
      component: () => import('@/views/SubscribedCodes'),
    }]
  },
  {
    path: '/SingleCodeAnalysis',
    component: Layout,
    children: [{
      path: '/',
      name: 'SingleCodeAnalysis',
      meta: { 
        title: 'Single Code Analysis'
      },
      component: () => import('@/views/SingleCodeAnalysis'),
    }]
  },
  {
    path: '/DownloadRawdata',
    component: Layout,
    children: [{
      path: '/',
      name: 'DownloadRawdata',
      meta: { 
        title: 'Download Rawdata'
      },
      component: () => import('@/views/DownloadRawdata'),
    }]
  },
  {
    path: '/FreeReport',
    component: Layout,
    children: [{
      path: '/',
      name: 'FreeReport',
      meta: { 
        title: 'Free Report'
      },
      component: () => import('@/views/FreeReport'),
    }]
  },
  {
    path: '/PaidReport',
    component: Layout,
    children: [{
      path: '/',
      name: 'PaidReport',
      meta: { 
        title: 'Paid Report'
      },
      component: () => import('@/views/PaidReport'),
    }]
  },
  {
    path: '/CombinationAnalysis',
    component: Layout,
    children: [{
      path: '/',
      name: 'CombinationAnalysis',
      meta: { 
        title: 'Combination Analysis'
      },
      component: () => import('@/views/CombinationAnalysis'),
    }]
  },
  {
    path: '/CombinationAnalysisTest',
    component: Layout,
    children: [{
      path: '/',
      name: 'CombinationAnalysisTest',
      meta: { 
        title: 'Combination Analysis'
      },
      component: () => import('@/views/CombinationAnalysis/Index'),
    },{
      path: '/CombinationAnalysis/Dashboard/:Cid',
      name: 'Dashboardpage',
      meta: { 
        title: 'Combination Analysis'
      },
      component: () => import('@/views/CombinationAnalysis/Dashboard.vue'),
    }]
  },
  {
    path: '/ComparisonAnalysis',
    component: Layout,
    children: [{
      path: '/',
      name: 'Comparison Analysis',
      meta: { 
        title: 'ComparisonAnalysis'
      },
      component: () => import('@/views/ComparisonAnalysis'),
    }]
  },
  {
    path: '/CustomizedStudy',
    component: Layout,
    children: [{
      path: '/',
      name: 'CustomizedStudy',
      meta: { 
        title: 'Customized Study'
      },
      component: () => import('@/views/CustomizedStudy'),
    }]
  },
  {
    path: '/LookForChinaCustomers',
    component: Layout,
    children: [{
      path: '/',
      name: 'LookForChinaCustomers',
      meta: { 
        title: 'Look For China Customers'
      },
      component: () => import('@/views/LookForChinaCustomers'),
    }]
  },
  {
    path: '/LookForSuppliers',
    component: Layout,
    children: [{
      path: '/',
      name: 'LookForSuppliers',
      meta: { 
        title: 'Look For Suppliers'
      },
      component: () => import('@/views/LookForSuppliers'),
    }]
  },
  {
    path: '/Profile',
    component: Layout,
    children: [{
      path: '/',
      name: 'Profile',
      meta: { 
        title: 'Profile'
      },
      component: () => import('@/views/Profile'),
    }]
  },
  /**
   * Admin
   */
  {
    path: '/Admin',
    name: 'Admin',
    component: Admin,
    meta: {
      title: "Admin"
    }
  },
  {
    path: '/ControlPanel',
    component: AdminLayout,
    redirect: '/ControlPanel/Intro',
    name: '',
    meta: { 
      title: 'ControlPanel'
    },
    children: [
      {
        path: 'Intro',
        name: 'Intro',
        component: () => import('@/views/Admin/ControlPanel/Intro'),
        meta: {
          title: 'Intro',
        }
      },
      {
        path: 'Email',
        name: 'Email',
        component: () => import('@/views/Admin/ControlPanel/Email'),
        meta: {
          title: 'Email',
        }
      },
      {
        path: 'Report',
        name: 'Report',
        component: () => import('@/views/Admin/ControlPanel/Report'),
        meta: {
          title: 'Report',
        }
      },
      {
        path: 'DataManagement',
        name: 'DataManagement',
        component: () => import('@/views/Admin/ControlPanel/DataManagement'),
        meta: {
          title: 'Data Management',
        }
      },
      {
        path: 'ReportManagement',
        name: 'ReportManagement',
        component: () => import('@/views/Admin/ControlPanel/ReportManagement'),
        meta: {
          title: 'Report Management',
        }
      },
      {
        path: 'ReportManagement/New',
        name: 'ReportManagementNew',
        component: () => import('@/views/Admin/ControlPanel/ReportManagementNew'),
        meta: {
          title: 'Report Management',
        }
      },
      {
        path: 'ReportManagement/Edit/:Cid',
        name: 'ReportManagementEdit',
        component: () => import('@/views/Admin/ControlPanel/ReportManagementEdit'),
        meta: {
          title: 'Report Management',
        }
      },
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
